export default "__VITE_ASSET__CWwxxq7h__"